export default __webpack_public_path__ + "static/media/privacy-policy-en-1.1d6469a4.jpg";